import React, { useState, useEffect, useRef } from 'react';
import { Icons, TextField, IconButton, InputAdornment } from "@curves/ui-base";
import useForkRef from '@util/hook/useForkRef';

const PasswordToggle = React.forwardRef((props, ref) => {
	const { value, onChange, label = '密碼', name, autoComplete = '', inputProps = {} } = props;
	const [internalValue, setInternalValue] = useState('');
	const [show, setShow] = useState(false);
	const localRef = useRef(null); // 預留用
	const combinedRef = useForkRef(ref, localRef);

	const handleChange = (_e, value) => {
		setInternalValue(value);
		onChange && onChange(value);
	};

	const handleToggle = () => {
		setShow(t => !t);
	};

	useEffect(
		() => {
			setInternalValue(value ?? internalValue);
		},
		// eslint-disable-next-line
		[value]
	);

	return (
		<TextField
			ref={combinedRef}
			label={label}
			name={name}
			helperText="密碼不得為空值"
			type={show ? 'text' : 'password'}
			value={internalValue}
			onChange={handleChange}
			inputProps={{ ...inputProps }}
			InputProps={{
				endAdornment: (
					<InputAdornment position={'end'}>
						<IconButton onClick={handleToggle}>{show ? <Icons.EyeSlash /> : <Icons.Eye />}</IconButton>
					</InputAdornment>
				)
			}}
			autoComplete={autoComplete || 'current-password'}
			fullWidth
			required
		/>
	);
});

export default PasswordToggle;
